<template>
  <div class="page padding">
    <!--  -->
    <b-card no-body>
      <div class="p-3">
        <h4 class="mb-1">
          {{ nombreProductor }}
          <br />
          <small>Informes</small>
        </h4>
      </div>      
      <b-row class="p-3">  
        <b-col sm="4">
        <!-- <b-col sm="5"> -->
          <label class="mr-4">Tipo de Informe</label>
          <v-select
            id="type-select"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="payload.tipo"
            :options="informes"
            label="text"   
            v-on:input="limpiar"
          ></v-select>          
        </b-col>                  
        <b-col sm="6">
        <!-- <b-col sm="5"> -->
          <label class="mr-2">Productor</label>
          <v-select
            id="type-select"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="payload.producer"
            :options="productores"
            label="text"
            :disabled="$role(['productor'])"
          ></v-select>          
        </b-col>        
      </b-row>   
      <b-row class="p-3" v-if="payload.tipo && !(payload.dateFromEmi || payload.dateToEmi)">
        <b-col sm="3">
             <label for="example-datepicker3">Fecha {{(payload.tipo && payload.tipo.value==0)?'de vigencia':'de cobranza'}} Desde...</label>
             <date-picker 
                 id="example-datepicker3" 
                 v-model="payload.dateFrom" 
                 :config="{format: 'MM/YYYY', minDate: minDate, useCurrent: false, showClear:true}" 
                 v-on:input="limpiarFecha(true);"
                 class="mb-1 mb-sm-0"           
                 placeholder="MM/AAAA"      
                 autocomplete="off"/> 
        </b-col>  
        <b-col sm="3">
             <label for="example-datepicker4">Fecha {{(payload.tipo && payload.tipo.value==0)?'de vigencia':'de cobranza'}} Hasta...</label>             
             <date-picker 
                 id="example-datepicker4" 
                 v-model="payload.dateTo" 
                 :config="{format: 'MM/YYYY', minDate: minDate, useCurrent: false, showClear:true}" 
                 v-on:input="limpiarFecha(true);"
                 class="mb-1 mb-sm-0"
                 placeholder="MM/AAAA"
                 autocomplete="off"/> 
        </b-col>  
      </b-row>   
      <b-row class="p-3" v-if="payload.tipo && payload.tipo.value == 0 && !(payload.dateFrom || payload.dateTo)">
        <b-col sm="3">
             <label for="example-datepicker1">Fecha de emisión Desde...</label>             
             <!--b-form-input type="date" v-model="payload.dateFromEmi" :min="minDate"/-->
             <date-picker 
                 id="example-datepicker1" 
                 v-model="payload.dateFromEmi"                  
                 :config="{format: 'MM/YYYY', minDate: minDate, useCurrent: false, showClear:true}" 
                 v-on:input="limpiarFecha(false);"
                 class="mb-1 mb-sm-0"       
                 placeholder="MM/AAAA"          
                 autocomplete="off"/> 
        </b-col>  
        <b-col sm="3">
             <label for="example-datepicker2">Fecha de emisión Hasta...</label>             
             <date-picker 
                 id="example-datepicker2" 
                 v-model="payload.dateToEmi"
                 :config="{format: 'MM/YYYY', minDate: minDate, useCurrent: false, showClear:true}" 
                 v-on:input="limpiarFecha(false);"
                 class="mb-1 mb-sm-0"
                 placeholder="MM/AAAA"
                 autocomplete="off"/> 
        </b-col>        
      </b-row>      
    <b-row v-if="payload.tipo">
        <b-col></b-col><b-col></b-col>
        <b-col rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block mb-4" sm="2">
          <b-btn class="btn-action" variant="primary" :disabled="loading || !payload.tipo || !validarPeriodo" @click="fetchResults"> Aceptar </b-btn>
        </b-col>
        <b-col></b-col>
    </b-row>
    </b-card>
    <b-card no-body v-if="results.length>0"> 
      <b-row>                   
        <b-col sm="12" class="text-right"><b-button class="btn-success m-2" @click="exportarShow">Exportar...</b-button></b-col>
      </b-row>        
        <b-table
            :items="results"
            :fields="columns[payload.tipo?payload.tipo.value:0].map(x => x.checked?x:null).filter(y => y!==null)"
            :per-page="perPage"
            :current-page="currentPage"
            style="margin-bottom:0;"
            responsive 
            striped>    
              <template #cell(Vencimiento)="data">
                {{formatoFecha(data.item.Vencimiento)}}
              </template>
              <template #cell(fec_cobranza)="data">
                {{formatoFecha(data.item.fec_cobranza)}}
              </template>
            </b-table>
            <b-card-footer>
                <b-row align-v="center">
                    <b-col>{{ registros }} de {{ results.length }} resultados</b-col>
                    <b-col> 
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="results.length"
                            :per-page="perPage"
                            aria-controls="my-table"
                        ></b-pagination>
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-card-footer>            
    </b-card>
    <b-modal id="exportar-modal" title="Exportar" hide-footer>
      <label for="report-select" class="my-2">Formato de reporte:</label>
      <b-select id="report-select" class="mb-2 mr-sm-2 mb-sm-0" v-model="formato" 
                :options="opcionesExport">            
      </b-select>
      <p class="my-2">Propiedades a mostar en el reporte:</p>
      <b-form-checkbox-group class="ml-5" v-model="reportCols" v-for="(col, index) in columns[payload.tipo?payload.tipo.value:0]" :key="index">                
        <b-form-checkbox class="mb-1" :value="col.key">{{col.label}}</b-form-checkbox>                
      </b-form-checkbox-group>
      <hr>
      <b-button id="exportararchivoButton" variant="success" @click="exportTo()" :disabled="exporting">Exportar Reporte</b-button>
    </b-modal>
  </div>
    <!--  -->  
</template>

<script>
import moment from 'moment';
import downloadDatatable from '@/helpers/download-datatable';
export default {
  data() {
    return {
      fechaFromEmi: null,
      minDate: moment(`${(new Date()).getFullYear()-2}-1-1`, 'YYYY-MM-DD'),
      loading: false,
      exporting: false,
      currentPage: 1,
      perPage: 10,
      opcionesExport: [{text:'PDF', value:'pdf'}, {text:'CSV', value:'csv'}, {text:'XLS', value:'xls'}],
      results: [],
      informes: [{text: 'Importe por Cuotas de Cada Póliza', value: 0}, 
                 {text: 'Importe pagado de cuota de cada Póliza', value: 1}],
      columns: [
               [{
                    key: 'Ramo',
                    label: 'Ramo',
                    checked: true
                },
                {
                    key: 'Poliza',
                    label: 'Poliza',
                    checked: true
                },
                {
                    key: 'Endoso',
                    label: 'Endoso',
                    checked: true
                },
                {
                    key: 'Cuota',
                    label: 'Cuota',
                    checked: true
                },
                {
                    key: 'Vencimiento',
                    label: 'Vencimiento',
                    checked: true
                },
                {
                    key: 'Importe',
                    label: 'Importe',
                    checked: true
                }], 
                [{
                    key: 'Ramo',
                    label: 'Ramo',
                    checked: true
                },
                {
                    key: 'Poliza',
                    label: 'Poliza',
                    checked: true
                },
                {
                    key: 'Endoso',
                    label: 'Endoso',
                    checked: true
                },
                {
                    key: 'fec_cobranza',
                    label: 'Fecha de Cobranza',
                    checked: true
                },
                {
                    key: 'nro_cuota',
                    label: 'Cuota',
                    checked: true
                },
                {
                    key: 'nro_correlativo',
                    label: 'Nro Correlativo',
                    checked: true
                },
                {
                    key: 'imp_premio_bruto',
                    label: 'Imp Premio Bruto',
                    checked: true
                }]],
      formato: 'pdf',
      reportCols: [],
      payload: {
                tipo: null, 
                producer: null,
                dateFrom: null,
                dateTo: null,
                dateFromEmi: null,
                dateToEmi: null
               }
    };
  },
  computed: {
    validarPeriodo(){
        let fechaDesde = this.payload.dateFrom?this.payload.dateFrom.split('/'):null;
        let fechaHasta = this.payload.dateTo?this.payload.dateTo.split('/'):null;
        if (!fechaDesde || !fechaHasta) {
          fechaDesde = this.payload.dateFromEmi?this.payload.dateFromEmi.split('/'):null;
          fechaHasta = this.payload.dateToEmi?this.payload.dateToEmi.split('/'):null;
        }

        if (!fechaDesde || !fechaHasta) return;       
        
        const desde = parseInt(''+fechaDesde[1]+fechaDesde[0]);
        const hasta = parseInt(''+fechaHasta[1]+fechaHasta[0]);

        return (hasta - desde) >= 0 && this.payload.producer;
    },
    nombreProductor() {
      return this.$store.getters['NOMBRE_PRODUCTOR'];
    },  
    registros(){
      return (this.perPage * this.currentPage < this.results.length)?(this.perPage * this.currentPage):this.results.length;
    },
    productores(){
        if (this.$role(['productor'])){
            let obj = {text: this.$store.getters['NOMBRE_PRODUCTOR']+' - '+this.$store.state.auth.cod_agente,
                       value: this.$store.state.auth.cod_agente};
            this.payload.producer = obj;
            return [obj];
        }else
        return this.$store.getters['productoresCartera']
    }
  },
  methods: {
    limpiarFecha(emision){
      if (emision){
        this.payload.dateFromEmi = null;
        this.payload.dateToEmi = null;
      }else{
        this.payload.dateFrom = null;
        this.payload.dateTo = null;
      }      
    },
    limpiar(){
      this.results = [];
      this.payload.dateFromEmi = null;
      this.payload.dateToEmi = null;
      this.payload.dateFrom = null;
      this.payload.dateTo = null;
    },
    formatoFecha(f){
      return moment(f).format('DD/MM/YYYY');
    },
    async fetchResults() {
      this.payload.formato = null;
      if (!this.payload.producer){
          this.$toast.error('Seleccione un productor para poder continuar.');
          return;
      }else this.payload.cod_agente = this.payload.producer.value;

      this.payload.informe = this.payload.tipo.value;
      this.payload.fecha_desde = moment(this.payload.dateFrom, 'MM/YYYY').startOf('month').format('YMMDD');
      this.payload.fecha_hasta = moment(this.payload.dateTo, 'MM/YYYY').endOf('month').format('YMMDD');
      if (this.payload.informe == 0 && this.payload.dateFromEmi){
        this.payload.fecha_emi_desde = moment(this.payload.dateFromEmi, 'MM/YYYY').startOf('month').format('YMMDD');
        this.payload.fecha_emi_hasta = moment(this.payload.dateToEmi, 'MM/YYYY').endOf('month').format('YMMDD');
      }

      this.loading = true;
      let loadScreen = this.$loading.show();
      this.$api.post('recursos/informes',
                    this.payload)
          .then(r => {
              this.results = r.data;
              this.loading = false;
              loadScreen.hide();
              if (this.results.length == 0) this.$toast.warning('La consulta no contiene resultados.', 'Atencion');
          })
    },

    exportarShow(){
        this.reportCols = this.columns[this.payload?this.payload.tipo.value:0].map(x => x.checked?x.key:null).filter(y => y != null);
        this.$bvModal.show('exportar-modal');
    },        
    exportTo(){
        this.exporting = true;
        if (this.formato == 'xls'){
          let loading = this.$loading.show();
          this.payload.formato="xls";
          this.payload.cols = this.reportCols;
          this.$api({
            method: 'POST',
            url: 'recursos/informes',
            data: this.payload,
            responseType: 'blob',
            headers: {
                      ContentType: 'multipart/form-data',
                    }})
          .then(r => {
              const fileURL = URL.createObjectURL(r.data);
              const link = document.createElement('a');
              link.setAttribute('href', encodeURI(fileURL));
              link.setAttribute('download', this.payload.tipo.text+'.xls');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              loading.hide();
          });
        }else
          downloadDatatable(this.results, this.columns[this.payload.tipo?this.payload.tipo.value:0].filter(x => this.reportCols.includes(x.key)), this.payload.tipo.text+'.'+this.formato);
        this.$bvModal.hide('exportar-modal');
        this.exporting = false;
    }
  },
}
</script>
